import { render, staticRenderFns } from "./DirectLogin.vue?vue&type=template&id=30502b46"
import script from "./DirectLogin.vue?vue&type=script&lang=js"
export * from "./DirectLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports